<template>
	<form @submit="onSubmit" id="GetNationalCodeForm" class="mt-2 d-block">
		<div v-if="step < 9">

			<div v-if="step==1">
				<b-form-group :label="$t('param.nationalCode')">
					<b-form-input type="number"
								  inputmode="numeric"
								  id="nationalCode"
								  :data-label="$t('param.nationalCode')"
								  class="form-control"
								  autocomplete="off"
								  v-model="nationalCode"
								  data-validations='["required","nationalcode"]'></b-form-input>
				</b-form-group>
				<b-form-group>
					<b-form-checkbox id="acceptTerms"
									 :data-label="$t('param.terms')"
									 v-model="acceptTerms"
									 value="true"
									 unchecked-value=""
									 name="acceptTerms"
									 data-validations='["required"]'>
						<a href="https://nicard.ir/content/Terms-and-conditions" target="_blank">قوانین و مقررات</a> را مطالعه کرده ام و میپذیرم.
					</b-form-checkbox>
					<b-form-checkbox id="subscribeToNews"
									 :data-label="$t('param.subscribeToNews')"
									 v-model="subscribeToNews"
									 value="true"
									 unchecked-value=""
									 name="subscribeToNews"
									 data-validations='[]'>
						با ارسال پیامک به منظور دریافت آخرین اطلاعات سامانه نیکارت موافقم
					</b-form-checkbox>

				</b-form-group>
			</div>
			<div v-if="step==2">
				<b-form-group :label="$t('param.personnelCode')">
					<b-form-input type="number"
								  inputmode="numeric"
								  id="personnelCode"
								  :data-label="$t('param.personnelCode')"
								  class="form-control"
								  autocomplete="off"
								  v-model="personnelCode"
								  data-validations='[]'></b-form-input>
				</b-form-group>
			</div>
			<div v-if="step==3">
				<b-form-group :label="$t('param.firstName')">
					<b-form-input type="text"
								  id="firstName"
								  :data-label="$t('param.firstName')"
								  class="form-control mb-2"
								  autocomplete="off"
								  v-model="firstName"
								  data-validations='["required"]'></b-form-input>
				</b-form-group>
				<b-form-group :label="$t('param.lastName')">
					<b-form-input type="text"
								  id="lastName"
								  :data-label="$t('param.lastName')"
								  class="form-control mb-2"
								  autocomplete="off"
								  v-model="lastName"
								  data-validations='["required"]'></b-form-input>
				</b-form-group>
			</div>
			<div v-if="step==4">
				<b-form-group :label="$t('param.mobile')">
					<b-form-input type="text"
								  id="mobile"
								  inputmode="numeric"
								  :data-label="$t('param.mobile')"
								  class="form-control mb-2"
								  autocomplete="off"
								  v-model="mobile"
								  data-validations='["required","mobile"]'></b-form-input>
				</b-form-group>
			</div>
			<div v-if="step==5">
				<div class="float-dynamic p-1 col-4">
					<b-form-group :label="$t('param.birthDay')">
						<b-form-select :options="birthDayOptions"
									   id="birthDay"
									   :data-label="$t('param.birthDay')"
									   class="form-control mb-2"
									   autocomplete="off"
									   v-model="birthDay"
									   data-validations='["required"]'></b-form-select>
					</b-form-group>
				</div>
				<div class="float-dynamic p-1 col-4">
					<b-form-group :label="$t('param.birthMonth')">
						<b-form-select :options="birthMonthOptions"
									   id="birthMonth"
									   :data-label="$t('param.birthMonth')"
									   class="form-control mb-2"
									   autocomplete="off"
									   v-model="birthMonth"
									   data-validations='["required"]'></b-form-select>
					</b-form-group>
				</div>
				<div class="float-dynamic p-1 col-4">
					<b-form-group :label="$t('param.birthYear')">
						<b-form-input type="number"
									  inputmode="numeric"
									  id="birthYear"
									  :data-label="$t('param.birthYear')"
									  class="form-control mb-2"
									  autocomplete="off"
									  v-model="birthYear"
									  data-validations='["required"]'></b-form-input>
					</b-form-group>
				</div>
			</div>


			<div v-if="step==6">
				<b-form-group :label="$t('param.organizationId')">
					<b-form-select type="text"
								   id="organizationId"
								   :options="organizations"
								   :data-label="$t('param.organizationId')"
								   class="form-control mb-2"
								   autocomplete="off"
								   v-model="organizationId"></b-form-select>
				</b-form-group>
			</div>


			<div v-if="step==7">
				<b-form-group :label="$t('param.password')">
					<b-form-input type="password"
								  id="password"
								  :data-label="$t('param.password')"
								  class="form-control"
								  autocomplete="off"
								  v-model="password"
								  data-validations='["required","password"]'></b-form-input>
				</b-form-group>
				<b-form-group :label="$t('param.repeatPassword')">
					<b-form-input type="password"
								  id="repeatPassword"
								  :data-label="$t('param.repeatPassword')"
								  class="form-control"
								  autocomplete="off"
								  v-model="repeatPassword"
								  data-validations='["required","password"]'></b-form-input>
				</b-form-group>
			</div>


			<div v-if="step==8">
				<b-form-group :label="$t('param.authCode')">
					<b-form-input type="text"
								  inputmode="numeric"
								  id="authCode"
								  :data-label="$t('param.authCode')"
								  class="form-control mb-2"
								  autocomplete="off"
								  v-model="authCode"
								  data-validations='["required"]'></b-form-input>
				</b-form-group>
			</div>


			<div class="alert alert-info flo mt-2 errors" v-if="duplicateNationalCode">
				<strong>ثبت نام کد ملی {{ nationalCode }} قبلا در سیستم انجام شده است!</strong>
				<p>می توانید وارد شوید و یا درصورتی که کلمه عبور خود را فراموش کرده اید می توانید از بخش "بازیابی کلمه عبور" کلمه عبور خود را بازیابی نمایید.</p>
				<div class="col-12 float-right">
					<div class="row">
						<button class="btn btn-block custom-outline-btn mt-2" type="button" @click="changeType('login')">
							<span>ورود</span>
						</button>
						<button class="btn btn-block custom-outline-btn mt-2" type="button" @click="changeType('forgetPassword')">
							<span>بازیابی کلمه عبور</span>
						</button>
					</div>
				</div>
			</div>


			<div class="alert alert-danger flo mt-2 errors" v-if="shahkarError">
				<strong>مالکیت شماره موبایل {{mobile}} متعلق به کد ملی {{nationalCode}} نمی باشد.</strong>
				<div class="col-12 float-right">
					<div class="row">
						<button class="btn btn-block custom-outline-btn mt-2" type="button" @click="changeType('login')">
							<span>تغییر شماره موبایل</span>
						</button>
					</div>
				</div>
			</div>

			<p class="alert alert-warning flo mt-2 errors" v-if="warnings.length">
				<label></label>
				<ul>
					<li v-for="warning in warnings">
						{{ $t(warning.type,{label:warning.label}) }}
					</li>
				</ul>
			</p>
			<p class="alert alert-danger mt-2 errors" v-if="errors.length">
				<label></label>
				<ul>
					<li v-for="error in errors">
						{{ $t(error.type) }}
					</li>
				</ul>
			</p>
			<div class="col-12 pr-0 pl-0 mt-2 float-right">
				<div class="col-2 pr-0 pl-1 float-right" v-if="step == 1">
					<a href="/" class="btn custom-outline-btn btn-block mt-2" type="button" @click="onPrev">
						<b-icon icon="house"></b-icon>
					</a>
				</div>
				<div class="col-2 pr-0 pl-1 float-right" v-if="step > 1">
					<button class="btn custom-outline-btn btn-block mt-2" type="button" @click="onPrev">
						<b-icon icon="arrow-right-short"></b-icon>
					</button>
				</div>
				<div class="pr-1 col-10 pl-0 float-right">
					<button class="btn btn-block custom-btn mt-2" type="submit" v-bind:disabled="loading">
						<span v-if="!loading">{{ $t('view.auth.next') }}</span>
						<span v-if="loading" class="spinner-border spinner-border-sm"></span>
					</button>
				</div>
			</div>
		</div>
		<b-modal v-model="subscribeToNewsModal" hide-header hide-footer id="subscribeToNewsModal">
			<div class="d-block text-center mt-3">
				<font-awesome-icon v-bind:style="{'font-size':'50px', 'color':'#ffcb0d'}" icon="exclamation-circle" />
				<div class="mt-3" style="font-size:16px;">درصورت تمایل به دریافت آخرین اطلاعات و رخدادهای سامانه نیکارت گزینه مربوط به آن را تیک بزنید و یا روی دکمه مایل به دریافت پیامک هستم کلیک نمایید. </div>
			</div>
			<div class="col-12 text-center mt-5">
				<b-button class="m-1 btn-dark" @click="()=>{ subscribeToNews = true; $bvModal.hide('subscribeToNewsModal')  }">مایل به دریافت پیامک هستم</b-button>
				<b-button class="m-1 btn-info" @click="$bvModal.hide('subscribeToNewsModal')">متوجه شدم</b-button>
			</div>
		</b-modal>
	</form>
</template>
<script>
	import store from "@/store";
	import utility from '@/plugins/utility';
	//import Mgr from '../../oidc/SecurityService'

	const db = new utility.db();

	export default {
		data()
		{
			return {
				step: 1,
				customer: {},
				loading: false,
				//mgr: new Mgr(),
				birthDayOptions: [
					{ text: "1", value: "01" },
					{ text: "2", value: "02" },
					{ text: "3", value: "03" },
					{ text: "4", value: "04" },
					{ text: "5", value: "05" },
					{ text: "6", value: "06" },
					{ text: "7", value: "07" },
					{ text: "8", value: "08" },
					{ text: "9", value: "09" },
					{ text: "10", value: "10" },
					{ text: "11", value: "11" },
					{ text: "12", value: "12" },
					{ text: "13", value: "13" },
					{ text: "14", value: "14" },
					{ text: "15", value: "15" },
					{ text: "16", value: "16" },
					{ text: "17", value: "17" },
					{ text: "18", value: "18" },
					{ text: "19", value: "19" },
					{ text: "20", value: "20" },
					{ text: "21", value: "21" },
					{ text: "22", value: "22" },
					{ text: "23", value: "23" },
					{ text: "24", value: "24" },
					{ text: "25", value: "25" },
					{ text: "26", value: "26" },
					{ text: "27", value: "27" },
					{ text: "28", value: "28" },
					{ text: "29", value: "29" },
					{ text: "30", value: "30" },
					{ text: "31", value: "31" },
				],
				birthMonthOptions: [
					{ text: "فروردین", value: "01" },
					{ text: "اردیبهشت", value: "02" },
					{ text: "خرداد", value: "03" },
					{ text: "تیر", value: "04" },
					{ text: "مرداد", value: "05" },
					{ text: "شهریور", value: "06" },
					{ text: "مهر", value: "07" },
					{ text: "آبان", value: "08" },
					{ text: "آذر", value: "09" },
					{ text: "دی", value: "10" },
					{ text: "بهمن", value: "11" },
					{ text: "اسفند", value: "12" },
				],
				warnings: [],
				errors: [],
				organizations: [],
				personnelCode: '',
				organizationId: '',
				showPersonnelCode: false,
				showOrganizationId: false,
				duplicateNationalCode: false,
				shahkarError:false,
				nationalCode: '',
				firstName: '',
				lastName: '',
				mobile: '',
				persianBirthDate: '',
				birthDay: '',
				birthMonth: '',
				birthYear: '',
				password: '',
				repeatPassword: '',
				authCode: '',
				acceptTerms: '',
				subscribeToNews: '',
				active: false,
				subscribeToNewsModal: false,
				subscribeToNewsModalShowed: false
			}
		},

		//beforeMount()
		//{
		//	this.mgr.getUser().then(
		//		user =>
		//		{
		//			if (user != null)
		//			{
		//				this.user = user;
		//				this.mobile = user.profile.name
		//				axios.defaults.headers.common['Authorization'] =
		//					'Bearer ' + user.access_token;
		//			}
		//			else
		//			{
		//				this.$router.push('/');
		//			}
		//		},
		//		err =>
		//		{
		//			this.$router.push('/');
		//		}
		//	)
		//},

		methods: {

			gotoClub()
			{
				this.request('/api/App/GetCustomerInfo', null, (response) =>
				{
					if (response)
					{
						store.customer = response.meta.Customer
						db.insert('__c', response.meta.Customer);

						const redirectPath = this.$route.query.redirect || "/club/dashboard";
						this.$router.push(redirectPath);
					}
					else
					{
						this.errors = [{ type: 'errors.server' }];
					}

				}, 'get');
			},

			changeType(value)
			{
				this.$emit('changeType', value)
			},


			changeMobileNumber()
			{
				const db = new utility.db();
				store.user = null;
				store.customer = null;
				store.token = null;
				db.delete("__c");
				db.delete("__t");

				//this.mgr.signOut()
			},

			onSubmit(evt)
			{
				var form = new utility.form('#GetNationalCodeForm');
				evt.preventDefault()
				this.warnings = form.errors();
				this.errors = [];

				if (this.warnings.length == 0)
				{

					if (this.subscribeToNews != "true" && this.subscribeToNewsModalShowed == false)
					{
						this.$bvModal.show('subscribeToNewsModal');
						this.subscribeToNewsModalShowed = true
						return;
					}


					if (this.step == 2)
					{
						this.request('/api/CustomerAuth/CheckNationalCode', {
							NationalCode: this.nationalCode,
							PersonnelCode: this.personnelCode,
							ApiRequestType: 'SignUp'
						}, (response) =>
						{
							if (response.success)
							{
								if (response.meta.customer != undefined)
								{
									store.customer = response.meta.customer
									this.customer = response.meta.customer
									this.firstName = response.meta.customer.firstName;
									this.lastName = response.meta.customer.lastName;
									this.mobile = response.meta.customer.mobile;
									this.organizationId = response.meta.customer.organizationId;
									this.persianBirthDate = response.meta.customer.persianBirthDate;

									if (this.persianBirthDate)
									{
										this.birthYear = this.persianBirthDate.split("/")[0];
										this.birthMonth = this.persianBirthDate.split("/")[1];
										this.birthDay = this.persianBirthDate.split("/")[2];
									}
								}

								if (response.meta.message == "Active Customer Found")
								{
									this.duplicateNationalCode = true;
								}
								else
								{
									this.step = 3;
								}
							}
						})
					}


					else if (this.step == 4)
					{
						this.request('/api/CustomerAuth/CheckDuplicateMobile',
							{
								NationalCode: this.nationalCode,
								PersonnelCode: this.personnelCode,
								Mobile: this.mobile,
							},
							(response) =>
							{
								if (response.success)
								{
									this.step = 5;
								}
								else
								{
									this.warnings.push({ type: 'validation.duplicateMobile' })
								}
							})
					}


					else if (this.step == 5)
					{
						this.persianBirthDate =
							this.birthYear + "/" +
							this.birthMonth + "/" +
							this.birthDay;

						if (form.isValidPersianDate(this.persianBirthDate))
						{
							if (this.organizationId == '' || this.organizationId == null)
							{
								this.request('/api/Organization/GetOrganization', null, (response) =>
								{
									if (response)
									{
										this.organizations = response.meta.organizations;
										this.loading = false;
										this.step = 6;
									}
								}, 'get')
							}
							else
							{
								this.step = 7
							}
						}
						else
						{
							this.warnings.push({ type: 'validation.invalid', label: "تاریخ تولد" })
						}
					}

					else if (this.step == 7)
					{
						if (this.password == this.repeatPassword)
						{
							this.request('/api/CustomerAuth/SaveInformation', {
								NationalCode: this.nationalCode,
								FirstName: this.firstName,
								LastName: this.lastName,
								Mobile: this.mobile,
								PersianBirthDate: this.persianBirthDate,
								CityID: this.cityId,
								Address: this.address,
								AuthCode: this.authCode,
								PassWord: this.password,
								OrganizationID: this.organizationId,
								PersonnelCode: this.personnelCode,
								AcceptTerms: this.acceptTerms == "true" ? true : false,
								subscribeToNews: this.subscribeToNews == "true" ? true : false,
							},
								(response) =>
								{
									if (response.success)
									{
										this.step = 8
									}
									else
									{
										if (response.meta.Message == "duplicate")
										{
											this.errors.push({ type: 'errors.personnelCode' })
										}

										else if (response.meta.Message == "shahkar error")
										{
											this.shahkarError = true;
										}

										else if (response.meta.Message == "shahkar server error")
										{
											this.errors.push({ type: 'errors.shahkarServerError' })
										}

										else
										{
											this.errors.push({ type: 'errors.noAccess' })
										}
									}
								}
							)
						}
						else
						{

							this.warnings.push({ type: 'validation.repeatPassword' })
						}
					}

					else if (this.step == 8)
					{
						this.request('/api/CustomerAuth/CheckAuthCode', { NationalCode: this.nationalCode, AuthCode: this.authCode }, (response) =>
						{
							if (response.success)
							{
								axios({
									method: 'post',
									url: '/create-token',
									headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
									data: 'username=' + this.nationalCode + '&password=' + this.password + '&grant_type=password'
								})
									.then(response =>
									{
										this.loading = false;
										if (response.data !== undefined)
										{
											if (response.data.access_token !== undefined)
											{
												store.token = response.data
												if (this.rememberMe)
													db.insert('__t', response.data);

												axios.defaults.headers.common['Authorization'] =
													'Bearer ' + store.token.access_token;

												this.gotoClub()
												return;
											}
										}

										this.errors = [{ type: 'errors.server' }];
									})
									.catch(error =>
									{
										this.loading = false;
										this.errors = [{ type: 'errors.server' }];
									});

								return;
							}

							this.warnings = [{ type: 'validation.auth' }];
						})
					}

					else this.step += 1;
				}
			},

			request(url, data, succees, method)
			{
				this.loading = true;

				var headers = {};
				method = method || 'post'

				if (url == '/create-token')
				{
					headers['Content-Type'] = 'application/x-www-form-urlencoded'
				}

				axios({
					method: method,
					url: url,
					headers: headers,
					data: data
				})
					.then(response =>
					{
						this.loading = false;

						if (response.data.success == false && response.data.meta.message == "Token not valid")
						{
							localStorage.clear();
							window.location.reload()
						}

						succees(response.data)
					})
					.catch(error =>
					{
						this.errors = [{ type: 'errors.server' }];
						this.loading = false;
					});
			},


			onPrev()
			{
				this.errors = []
				if (this.step == 1)
				{
					this.$emit('changeType', 'login')

				} else
				{
					this.step -= 1
				}
			}
		}
	};
</script>
